<section id="commitments" data-trust-finale class="trust-finale">
  <div class="trust-finale__glow" aria-hidden="true"></div>
  <div class="trust-finale__inner">
    <header class="trust-finale__intro">
      <span class="trust-finale__eyebrow">Một hệ sinh thái · Một chuẩn phục vụ</span>
      <h2>{{ content.title }}</h2>
      <p>{{ content.description }}</p>
    </header>

    <div class="trust-finale__rail" aria-hidden="true"></div>
    <div class="trust-finale__seals">
      <article
        *ngFor="let item of content.items; let index = index"
        data-commitment-seal
        class="commitment-seal"
        [class.commitment-seal--raised]="index % 2 === 1"
      >
        <span class="commitment-seal__number">0{{ index + 1 }}</span>
        <span class="commitment-seal__icon" [ngClass]="item.accent">
          <mat-icon [svgIcon]="'hero:' + item.icon"></mat-icon>
        </span>
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </article>
    </div>
  </div>
</section>
